import React, { FC, useContext } from 'react'
import { Trans, Plural } from '@lingui/macro'
import BorderedBox from '../../../../components/common/bordered-box/BorderedBox'
import Tag from '../../../../components/common/tag/Tag'
import classNames from 'classnames'
import {
  ICampaignActionItemListProps,
  ManageCampaignContext
} from '../../ManageCampaignPage'

import Loader from '../../../../components/common/loader/Loader'

import { useQueryParam, ArrayParam } from 'use-query-params'
import {
  CertificationsByIdsQuery,
  useCertificationsForCampaignShareActionQuery,
  useCertificationsByIdsQuery
} from './CampaignCertificationShareList.codegen'

const Header: FC<{ count: number }> = ({ count }) => {
  return (
    <h3>
      <Plural
        value={count}
        one="# Certification Selected"
        other="# Certifications Selected"
      />
    </h3>
  )
}

const CertificationBox: FC<{
  certifications: NonNullable<
    NonNullable<CertificationsByIdsQuery['admin']>['organisation']
  >['certifications']
}> = ({ certifications }) => {
  return (
    <>
      {certifications.map((certification) => {
        return (
          <BorderedBox
            key={certification.id}
            className={classNames('List__Row', {
              [`List__Row--deleted`]: certification.deleted_at
            })}
          >
            <strong>{certification.name}</strong>
            <span>
              {certification.deleted_at && (
                <Tag color="redOpen" size="small">
                  <Trans>Archived</Trans>
                </Tag>
              )}
            </span>
          </BorderedBox>
        )
      })}
    </>
  )
}

export const CampaignCertificationShareList: FC<ICampaignActionItemListProps> =
  ({ actionId }) => {
    const { campaign } = useContext(ManageCampaignContext)
    const { data, loading } = useCertificationsForCampaignShareActionQuery({
      variables: { campaignId: campaign.id, actionId }
    })
    if (loading) {
      return <Loader />
    }
    const actionCertifications =
      data?.admin?.campaign?.certificationShareAction?.actionCertifications
    if (!actionCertifications) {
      return null
    }

    return (
      <>
        <Header count={actionCertifications.length} />
        <CertificationBox
          certifications={actionCertifications.map((a) => a.certification)}
        />
      </>
    )
  }

export const CampaignNewCertificationShareList: FC = () => {
  const [selectedIds] = useQueryParam('selectedIds', ArrayParam)

  const { data } = useCertificationsByIdsQuery({
    variables: {
      ids:
        selectedIds?.map((id) => {
          return Number(id)
        }) ?? []
    }
  })
  const certifications = data?.admin?.organisation?.certifications
  if (!certifications) {
    return null
  }

  return (
    <>
      <Header count={certifications.length} />
      <CertificationBox certifications={certifications} />
    </>
  )
}
